// Decorative background video loops (CC-licensed, Wikimedia transcodes — hotlink-friendly).
// Rendered grayscale (B&W) with a brand-red overlay; poster image is always shown as fallback.
export const BG_VIDEOS = {
  gym: "https://upload.wikimedia.org/wikipedia/commons/transcoded/2/20/Barbell_Jerk.webm/Barbell_Jerk.webm.480p.vp9.webm",
  volleyball:
    "https://upload.wikimedia.org/wikipedia/commons/transcoded/6/63/Beach_volleyball_in_Korea_2014.webm/Beach_volleyball_in_Korea_2014.webm.480p.vp9.webm",
};

export const BG_POSTERS = {
  gym: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&q=70&auto=format&fit=crop",
  volleyball: "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=1600&q=70&auto=format&fit=crop",
};
